import { lazy } from 'react'

export const KitChallengesYouFacedV1 = lazy(
  () => import('./kitV1/KitChallengesYouFacedV1'),
)
export const ChallengesYouFacedV1 = lazy(
  () => import('./v1/ChallengesYouFacedV1'),
)
